import React from 'react';
import AsyncPage from './async';
import DefaultConsumerLayout from '../../../../components/layout/DefaultConsumerLayout';

export default [
  <DefaultConsumerLayout
    key="/consumer/features/remove-background-from-image"
    exact
    path="/consumer/features/remove-background-from-image"
    component={AsyncPage}
  />,
];
